import { atom, swr } from '@exodus/headless-ui';
import { isLoadingAtom, quoteAtom, swapModeAtom } from './index.js';
const isFromLoadingAtom = atom((get) => {
    const isInitialLoading = get(isLoadingAtom);
    const isExactIn = get(swapModeAtom) === 'ExactIn';
    const isLoadingData = isExactIn ? false : get(swr(quoteAtom)).loading;
    return isInitialLoading || isLoadingData;
});
export default isFromLoadingAtom;
